<script lang="ts">
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let threadName = '';

    let selectedImage: File | null = null;
    let imagePreviewUrl: string | null = null;
    let fileInputElement: HTMLInputElement;

    onDestroy(() => {
        if (exists(imagePreviewUrl)) {
            URL.revokeObjectURL(imagePreviewUrl);
        }
    });

    const handleImageClick = () => {
        if (exists(fileInputElement)) {
            fileInputElement.click();
        }
    };

    const handleFileChange = (event: Event) => {
        const input = event.target as HTMLInputElement;
        const files = input.files;

        if (!exists(files) || files.length === 0) {
            return;
        }

        if (exists(imagePreviewUrl)) {
            URL.revokeObjectURL(imagePreviewUrl);
        }

        selectedImage = files[0];
        imagePreviewUrl = URL.createObjectURL(selectedImage);
    };
</script>

<div class="image-selector-container">
    <button type="button" class="image-selector-button" on:click={handleImageClick}>
        {#if imagePreviewUrl}
            <img src={imagePreviewUrl} alt="Selected group icon" class="selected-image"/>
        {:else}
            <UIcon icon="mode-landscape"/>
        {/if}
    </button>

    <small class="text-center text-muted">
        Kliknutím vyberte obrázek ikony skupiny (není povinné)
    </small>

    <input class="sr-only"
           type="file"
           accept="image/*"
           bind:this={fileInputElement}
           on:change={handleFileChange}/>
</div>

<KpValueEditor type="text" placeholder="Název konverzce" bind:model={threadName}/>

<div class="user-selector-container">
    <KpButton buttonStyle="no-background" isBlock>
        <IconedContent icon="add">
            Přidat účastníka
        </IconedContent>
    </KpButton>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @selector-size: 154px;

    .image-selector-container {
        display: flex;
        gap: @spacing-sm;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .image-selector-button {
            background: none;
            border: 1px solid @themed-border-default;
            border-radius: 50%;
            width: @selector-size;
            height: @selector-size;
            display: flex;
            padding: 0;
            font-size: 48px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            outline: 2px solid transparent;
            outline-offset: 2px;
            color: @themed-text-muted;
            transition: outline-color 0.3s ease-in-out;
            overflow: hidden;

            &:hover {
                outline-color: var(--accent-blue-new);
            }

            .selected-image {
                width: 100%;
                height: 100%;
                padding: 0;
                margin: 0;
                object-fit: cover;
            }
        }

        .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }
    }

    .user-selector-container {
        display: flex;
        flex-direction: column;
        gap: @spacing-l;
    }
</style>